import { FC } from "react";
import settings from "/svg/settings.svg";
// import reactions from "/svg/favourite.svg";
import { Link, useLocation } from "react-router-dom";
import { ThemeToggle } from "@features/theme";
import { AppRoutes } from "@shared/constants";
import { useGetApiProfileQuery } from "@shared/api";
import share from "/svg/share.svg";

import styles from "./Header.module.scss";

export const Header: FC = () => {
  const location = useLocation();
  const { data: profile } = useGetApiProfileQuery();

  const getProfileLink = () => {
    const name = profile?.data?.username;
    const tgUserName = window.Telegram.WebApp.initDataUnsafe.user?.username;

    if (!name && !tgUserName) return "#";
    const url = encodeURIComponent("https://t.me/hive_app_bot");
    const text = encodeURIComponent(
      `Привет! Найди меня в приложении Hive по нику - @${tgUserName || name}`
    );
    return `https://t.me/share/url?text=${text}&url=${url}`;
  };

  return (
    <div className={styles.header}>
      {location.pathname === AppRoutes.MATCH ? (
        <Link to="/settings">
          <img src={settings} className={styles.headerIcon} />
        </Link>
      ) : (
        <ThemeToggle />
      )}
      <a href={getProfileLink()}>
        <img className={styles.shareButton} src={share} />
      </a>
    </div>
  );
};
